import styles from "../../styles/playerEcosystem.module.css";

/**
 * Unlocked personal records / milestones.
 * @param {{ records: Array<{ id: string, title: string, detail: string, whenLabel?: string }> }} props
 */
export default function PersonalRecordsGrid({ records }) {
  if (!records?.length) {
    return <p className={styles.muted}>Records unlock as you play — first match, streaks, milestones.</p>;
  }
  return (
    <div className={styles.recordsGrid} aria-label="Personal records">
      {records.map((r) => (
        <article key={r.id} className={styles.recordCard}>
          <p className={styles.statLabel}>{r.title}</p>
          <p className={styles.statValue} style={{ fontSize: "1rem" }}>
            {r.detail}
          </p>
          {r.whenLabel ? <p className={styles.muted}>{r.whenLabel}</p> : null}
        </article>
      ))}
    </div>
  );
}
